import { makeStyle } from '../../../../../utils';
import { columnCenter, h5, black, rowCenter, blackOutline, button } from '../../../../../resources/styles';
import view from '../../../../../Enums';
import { makeStyles } from '@material-ui/core';

const styles = {};

styles['container'] = makeStyle([columnCenter, { backgroundColor: 'white', zIndex: 1 }]);

styles['header'] = makeStyle([rowCenter, {
    padding: '0 20px',
    alignSelf: 'stretch'
}], { borderBottom: `1px solid ${blackOutline.color}` }, { display: 'none' }, view.TAB);

styles['scrollable_header'] = makeStyle([rowCenter, { justifyContent: 'space-between', marginBottom: 24 }], { display: 'none' });

styles['back_icon'] = makeStyle({ padding: '8px 0' }, { display: 'none' });

styles['skip'] = makeStyle({
    borderRadius: 6,
    textAlign: 'center',
    padding: '8px 16px',
    ...button,
});

styles['title'] = makeStyle([h5, black, { padding: '29px 0', letterSpacing: '-0.28px', marginLeft: 14, flex: 1 }]);

styles['submit'] = makeStyle({
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 16px',
    minWidth: 156,
    ...button,
    marginLeft: 24,
    display: 'none'
}, { display: 'block' });

styles['bottom_submit'] = makeStyle({
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 16px',
    minWidth: 156,
    marginTop: 24,
    position: 'relative', left: '50%', transform: 'translateX(-50%)',
    ...button,
}, { display: 'none' })

styles['content'] = makeStyle({ flex: 1, overflowY: 'auto', width: '100%' });

styles['form'] = makeStyle({
    width: '100%',
    maxWidth: 700,
    margin: '0 auto',
    padding: '24px 24px 200px',
    boxSizing: 'border-box'
}, null, null, { padding: '16px 16px 200px', });

styles['banner_wrapper'] = makeStyle({ padding: '0 32px 64px', width: 'max-content', margin: 'auto' });

export default styles;